import axios from 'axios';

import { addProfileVote } from './ProfileActions';

// --------------------------------------
//              ACTION TYPES
// --------------------------------------
export const POLLS_QUESTIONS_GET_START = 'POLLS_QUESTIONS_GET_START';
export const POLLS_QUESTIONS_GET_SUCCESS = 'POLLS_QUESTIONS_GET_SUCCESS';
export const POLLS_QUESTIONS_GET_FAIL = 'POLLS_QUESTIONS_GET_FAIL';

export const POLLS_VOTE_POST_START = 'POLLS_VOTE_POST_START';
export const POLLS_VOTE_POST_SUCCESS = 'POLLS_VOTE_POST_SUCCESS';
export const POLLS_VOTE_POST_FAIL = 'POLLS_VOTE_POST_FAIL';

export const POLLS_FILTERED_GET_START = 'POLLS_FILTERED_GET_START';
export const POLLS_FILTERED_GET_SUCCESS = 'POLLS_FILTERED_GET_SUCCESS';
export const POLLS_FILTERED_GET_FAIL = 'POLLS_FILTERED_GET_FAIL';

function normalizeFilteredPollResponse(data, fallbackPage = 1, fallbackPageSize = 20) {
  if (Array.isArray(data)) {
    return {
      items: data,
      pagination: {
        count: data.length,
        next: null,
        page: fallbackPage,
        page_size: fallbackPageSize,
        previous: null
      }
    };
  }

  const results = Array.isArray(data?.results) ? data.results : [];

  return {
    items: results,
    pagination: {
      count: Number(data?.count || 0),
      next: data?.next || null,
      page: Number(data?.page || fallbackPage),
      page_size: Number(data?.page_size || fallbackPageSize),
      previous: data?.previous || null
    }
  };
}

// --------------------------------------
//            ACTION CREATORS
// --------------------------------------

// GET:
export const getPollsQuestionsStart = () => ({
  type: POLLS_QUESTIONS_GET_START
});

export const getPollsQuestionsSuccess = (questions) => ({
  type: POLLS_QUESTIONS_GET_SUCCESS,
  questions,
  latest: questions[0]
});

export const getPollsQuestionsFail = (error) => ({
  type: POLLS_QUESTIONS_GET_FAIL,
  error
});

export const getPollsQuestions = () => (dispatch, getState) => {
  dispatch(getPollsQuestionsStart());
  const language = getState().i18nState.lang;
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/polls/questions?lang=${language}&paginated=1&page_size=20`
    )
    .then((res) => {
      const questions = Array.isArray(res.data)
        ? res.data
        : res.data?.results || [];
      dispatch(getPollsQuestionsSuccess(questions));
      return getState().PollsState.items;
    })
    .catch((err) => {
      dispatch(getPollsQuestionsFail(err));
      throw err;
    });
};

// POST:
export const postPollsVoteStart = () => ({
  type: POLLS_VOTE_POST_START
});

export const postPollsVoteSuccess = (vote) => ({
  type: POLLS_VOTE_POST_SUCCESS,
  vote
});

export const postPollsVoteFail = (error) => ({
  type: POLLS_QUESTIONS_GET_FAIL
});

export const postPollsVote = (payload, latest_vote = false) => (dispatch, getState) => {
  dispatch(postPollsVoteStart());
  return axios
    .post(`${process.env.REACT_APP_API_URL}/polls/vote`, payload)
    .then((res) => {
      dispatch(postPollsVoteSuccess(payload));
      if (latest_vote) {
        dispatch(addProfileVote(true));
      }
    })
    .catch((err) => {
      dispatch(postPollsVoteFail(err));
      throw err;
    });
};

export const getFilteredPollsStart = () => ({
  type: POLLS_FILTERED_GET_START
});

export const getFilteredPollsSuccess = (payload) => ({
  type: POLLS_FILTERED_GET_SUCCESS,
  append: Boolean(payload?.append),
  filteredPolls: payload?.items || [],
  pagination: payload?.pagination || {
    count: 0,
    next: null,
    page: 1,
    page_size: 20,
    previous: null
  }
});

export const getFilteredPollsFail = (error) => ({
  type: POLLS_FILTERED_GET_FAIL,
  error
});

export const getFilteredPolls = (filters = {}, options = {}) => (dispatch, getState) => {
  dispatch(getFilteredPollsStart());

  const language = getState().i18nState.lang;
  const page = Number(options.page || 1);
  const pageSize = Number(options.page_size || 20);
  const params = new URLSearchParams();

  if (language) params.append('lang', language);
  if (filters.country) params.append('country', filters.country);
  if (filters.gender) params.append('gender', filters.gender);
  if (filters.nationality) params.append('nationality', filters.nationality);
  if (filters.age) params.append('age', filters.age);
  if (filters.profile_id) params.append('profile_id', filters.profile_id);

  if (options.paginated !== false) {
    params.append('paginated', '1');
    params.append('page', String(page));
    params.append('page_size', String(pageSize));
  }

  return axios
    .get(
      `${
        process.env.REACT_APP_API_V2_URL
      }/polls-questions-filter?${params.toString()}`,
      {
        signal: options.signal
      }
    )
    .then((res) => {
      const normalized = normalizeFilteredPollResponse(res.data, page, pageSize);
      dispatch(
        getFilteredPollsSuccess({
          ...normalized,
          append: Boolean(options.append)
        })
      );
      return normalized;
    })
    .catch((err) => {
      dispatch(getFilteredPollsFail(err));
      throw err;
    });
};
